import React from 'react'
import { FlatButton } from 'material-ui'
import { red500 } from 'material-ui/styles/colors'
import Item from './item'

const errorTextStyle = {
  color: red500,
  fontSize: '0.8em'
}

class MultiInput extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.handleRef = this.handleRef.bind(this)
    this.handleAdd = this.handleAdd.bind(this)
// @ts-ignore
    this.latestRef = null
  }

  handleAdd () {
    const { onChange, value: values } = this.props
    onChange(null, [...values, ''])
  }

  handleChange (index, newValue) {
    const { onChange, value: values } = this.props
    onChange(null, [
      ...values.slice(0, index),
      newValue,
      ...values.slice(index + 1)
    ])
  }

  handleDelete (index) {
    const { onChange, value: values } = this.props
    onChange(null, [
      ...values.slice(0, index),
      ...values.slice(index + 1)
    ])
  }

  handleRef (ref) {
// @ts-ignore
    this.latestRef = ref
  }

  componentDidUpdate (prevProps) {
    const oldValue = prevProps.value
    const { onAdd, value: newValue } = this.props

    // If we treat the latest item ref as a newly added item that means the
    // initial render would trigger that event instead of waiting for the user
    // to interact with the "add" button.
    // This should still probably be better off as state and action but it works
    // for now.
    const haveNewItem = newValue && (!oldValue || oldValue.length < newValue.length)

// @ts-ignore
    if (haveNewItem && this.latestRef && onAdd) {
// @ts-ignore
      onAdd(this.latestRef)
    }
  }

  render () {
    const {
      label,
      addItemText,
      minItems,
      component,
      componentProps,
      errorText,
      value: values
    } = this.props

    return (
      <div style={{ marginTop: '1em' }}>
        <label>{label}</label>
        <div>
          {values.map((item, i) => (
            <Item
              key={i}
              name={`item-${i}`}
              value={item}
              component={component}
              onChange={(e, value) => this.handleChange(i, value)}
              deletable={minItems === 0 || i >= minItems}
              onDelete={() => this.handleDelete(i)}
              {...componentProps}
              onRef={i === values.length - 1 ? this.handleRef : null}
            />
          ))}
        </div>
        {errorText
          ? <p style={errorTextStyle}>{errorText}</p>
          : null}
        <FlatButton
          primary
          label={addItemText}
          onClick={this.handleAdd}
        />
      </div>
    )
  }
}

// @ts-ignore
MultiInput.propTypes = {
  onChange: React.PropTypes.func.isRequired,
// @ts-ignore
  component: React.PropTypes.elementType.isRequired,
  componentProps: React.PropTypes.object,
  addItemText: React.PropTypes.string,
  minItems: React.PropTypes.number,
  value: React.PropTypes.array
}

// @ts-ignore
MultiInput.defaultProps = {
  componentProps: {},
  addItemText: 'Add',
  minItems: 0,
  value: []
}

export default MultiInput
